(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('SearchController', SearchController);


    SearchController.$inject = [
        '$rootScope',
        '$scope',
        'ordersService',
        '$templateCache',
        '$filter',
        '$window',
        'preferences',
        '$state',
        'reportService',
        'runtimeStates'        
    ];

    function SearchController($rootScope, $scope, ordersService, $templateCache, $filter, $window, preferences, $state, reportService, runtimeStates) {

        /* PRIVATE VARIABLES */
        var templates = {
            rowTemplate: $templateCache.get('app/views/tablesTemplates/orders/rowTemplate.html'),
            stateTemplate: $templateCache.get('app/views/tablesTemplates/orders/stateTemplate.html'),
            actionsTemplate: $templateCache.get('app/views/tablesTemplates/orders/actionsTemplate.html'),
            headerTemplate: $templateCache.get('app/views/tablesTemplates/logistics/customHeaderTemplate.html'),
            ubicacionRec: $templateCache.get('app/views/tablesTemplates/generic/ubicacionRecTemplate.html'),
            ubicacionEnt: $templateCache.get('app/views/tablesTemplates/generic/ubicacionEntTemplate.html')
        };
        var paginationOptions = {
            pageNumber: 1,
            pageSize: 25,
            sort: { field: 'date', direction: 'desc' }
        };
        var sorting = {
            field: 'date',
            direction: 'desc'
        };
        
        var vm = this;

        vm.searchText = '';
        vm.getOrdersData = getOrdersData;
        vm.clearAll = clearAll;
        vm.frequencyFields = computeFreqFieldsByOrderType(); 
        vm.appliedFilters = [];
        vm.mostrarDadosBaja = 0;
        vm.getBackgroundColor = getBackgroundColor;
        vm.getColorEstado = getColorEstado;
        vm.getEstadoName = getEstadoName;
        vm.refreshData = refreshData;
        vm.refreshGrid = refreshGrid;
        vm.goToEdit = goToEdit;
        vm.tab = $rootScope.tabManager.tabs[$rootScope.tabManager.indexOfState($state.$current.name)];
        vm.reportService = reportService;
        vm.changeOrderState = changeOrderState;
        vm.remove = remove;

        //Grid
        $scope.gridData = null;
        vm.gridApi = null;
        vm.focusedRow = null;
        vm.loadingInformation = true;
        vm.gridOptions = {
            rowTemplate: templates.rowTemplate,

            enableGridMenu: true,

            paginationPageSizes: [25, 50, 75],
            paginationPageSize: 25,
            useExternalPagination: true,
            useExternalSorting: true,

            enableRowSelection: true,
            multiSelect: true,

            enableColumnResizing: true,

            enableColumnMenus: false,
            treeRowHeaderAlwaysVisible: false,
            virtualizationThreshold: 200,

            primaryKey: 'id',

            columnDefs: computeColumnsByOrderType(),
            data: 'gridData',
            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
                vm.gridApi.grid.options.enableExpandAll = false;

                vm.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    if (sortColumns.length > 0) {
                        sorting.field = sortColumns[0].field;
                        sorting.direction = sortColumns[0].sort.direction;
                    } else {
                        sorting = { field: null, direction: null };
                    }
                    getOrdersData();
                });
                vm.gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    paginationOptions.pageNumber = newPage;
                    paginationOptions.pageSize = pageSize;
                    getOrdersData();

                });
                vm.gridApi.core.on.columnVisibilityChanged($scope, function (changedColumn) {
                    saveColumnsVisibilityState();
                });
            }
        };
        
        /* INITIALIZER */
        (function () {
            vm.searchText = $state.params.q;

            vm.getOrdersData();

            setColumnVisibility();
        })();

        function getOrdersData(success) {
            vm.loadingInformation = false;
            var skip = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
            var take = paginationOptions.pageSize;
            ordersService.getAllOrders(skip, take, sorting,
                vm.appliedFilters, vm.mostrarDadosBaja ? 1 : 0,
                vm.frequencyFields, vm.searchText).then(function (result) {
                    $scope.gridData = result.data.list;
                    vm.gridOptions.totalItems = result.data.count;
                    vm.refreshing = false;
                    vm.loadingInformation = true;
                    if (success) {
                        notificationService.sendAppNotification({
                            message: 'Orden eliminada con éxito',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                        });
                    }
                    //Mantain the selected row after loading the new data
                    var selected = vm.gridApi.selection.getSelectedRows();
                    vm.clearAll();
                    for (var i = 0; i < $scope.gridData.length; i++) {
                        var found = $filter('filter')(selected, { 'orderId': $scope.gridData[i].orderId });
                        if (found[0]) {
                            vm.gridApi.grid.modifyRows($scope.gridData);
                            vm.gridApi.selection.selectRow($scope.gridData[i]);
                        }
                    }
                });
        }

        function computeColumnsByOrderType() {
            if (preferences.prefs.sector === 'GRU') {
                return [
                    {
                        field: 'state',
                        displayName: 'Estado',
                        width: '*',
                        resizable: true,
                        cellTemplate: templates.stateTemplate,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'nombreEmpresa',
                        displayName: 'Empresa',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'jobOrder',
                        displayName: 'Nº Orden',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'expedient',
                        displayName: 'Expediente',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'clientName',
                        displayName: 'Cliente',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'date',
                        displayName: 'Fecha',
                        width: '*',
                        resizable: true,
                        cellFilter: 'date: "dd/MM/yyyy HH:mm"',
                        sort: { priority: 1, direction: 'desc' },
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'brand',
                        displayName: 'Marca',
                        width: '*',
                        resizable: true,
                        visible: false,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'model',
                        displayName: 'Modelo',
                        width: '*',
                        resizable: true,
                        visible: false,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'plate',
                        displayName: 'Matrícula',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
                    },
					/*{
						field: 'pickupTown',
						displayName: 'Población',
						width: '*',
						resizable: true,
						visible: false,
						headerCellTemplate: templates.headerTemplate
					},*/
                    {
                        field: 'pickupAddress',
                        displayName: 'Dirección de recogida',
                        width: '*',
                        resizable: true,
                        visible: false,
                        cellTemplate: templates.ubicacionRec,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'deliveryAddress',
                        displayName: 'Dirección de entrega',
                        width: '*',
                        resizable: true,
                        visible: false,
                        cellTemplate: templates.ubicacionEnt,
                        headerCellTemplate: templates.headerTemplate
                    },


                    {
                        field: 'fault',
                        displayName: 'Avería',
                        width: '*',
                        resizable: true,
                        cellFilter: 'capitalize',
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        name: 'acciones',
                        displayName: 'Acciones',
                        width: 150,
                        resizable: true,
                        cellClass: 'overflow',
                        cellTemplate: templates.actionsTemplate,
                        enableHiding: false,
                        enableSorting: false
                    }
                ];
            }
            else if (preferences.prefs.sector === 'TAX') {
                return [
                    {
                        field: 'state',
                        displayName: 'Estado',
                        width: '*',
                        resizable: true,
                        cellTemplate: templates.stateTemplate,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'nombreEmpresa',
                        displayName: 'Empresa',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'jobOrder',
                        displayName: 'Nº Orden',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'expedient',
                        displayName: 'Expediente',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'clientName',
                        displayName: 'Cliente',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'date',
                        displayName: 'Fecha',
                        width: '*',
                        resizable: true,
                        cellFilter: 'date: "dd/MM/yyyy HH:mm"',
                        sort: { priority: 1, direction: 'desc' },
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'plate',
                        displayName: 'Matrícula',
                        width: '*',
                        resizable: true,
                        headerCellTemplate: templates.headerTemplate
                    },

					/*{
						field: 'pickupTown',
						displayName: 'Población',
						width: '*',
						resizable: true,
						visible: false,
						headerCellTemplate: templates.headerTemplate
					},*/

                    {
                        field: 'pickupAddress',
                        displayName: 'Dirección de recogida',
                        width: '*',
                        resizable: true,
                        visible: false,
                        cellTemplate: templates.ubicacionRec,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        field: 'deliveryAddress',
                        displayName: 'Dirección de entrega',
                        width: '*',
                        resizable: true,
                        visible: false,
                        cellTemplate: templates.ubicacionEnt,
                        headerCellTemplate: templates.headerTemplate
                    },
                    {
                        name: 'acciones',
                        displayName: 'Acciones',
                        width: 150,
                        resizable: true,
                        cellClass: 'overflow',
                        cellTemplate: templates.actionsTemplate,
                        enableHiding: false,
                        enableSorting: false
                    }
                ];
            }
        }

        function saveColumnsVisibilityState() {
            var columns = [];
            angular.forEach(vm.gridOptions.columnDefs, function (value, key) {
                columns.push({ displayName: value.displayName, visible: value.visible === false ? false : true });
            });
            $window.localStorage.setItem('colVisibilityOrd', angular.toJson(columns));
            //userService.saveColumnConfig(columns, 'flotaordeneslistado');
        }

        function setColumnVisibility() {
            //var columns = userService.getColumnConfig('flotaordeneslistado') || []; 
            var columns = angular.fromJson($window.localStorage['colVisibilityOrd']) || [];

            if (!columns) { return; }
            angular.forEach(vm.gridOptions.columnDefs, function (value, key) {
                var col = $filter('filter')(columns, { displayName: value.displayName })[0];
                if (col) {
                    value.visible = col.visible !== false;
                }
            });
        }

        function clearAll() {
            vm.gridApi.selection.clearSelectedRows();
        }

        function computeFreqFieldsByOrderType() {
            if (preferences.prefs.sector === 'GRU') {
                return ['expedient', 'plate', 'jobOrder'];
            }
            else if (preferences.prefs.sector === 'TAX') {
                return ['expedient', 'plate', 'jobOrder'];
            }
        }

        function getBackgroundColor(order) {
            return preferences.prefs.getStateColor(order.state) || 'undefined';
        }

        function getColorEstado(state) {
            return preferences.prefs.getStateColor(state) || 'undefined';
        }

        function getEstadoName(estado) {
            return preferences.prefs.getStateDesc(estado) || 'undefined';
        }

        function refreshData(success) {
            vm.refreshing = true;
            getOrdersData(success);
        }
        
        function refreshGrid() {
            getOrdersData();
        }

        function changeOrderState(orderId, state) {
            ordersService.legacyChangeOrderState(orderId, state)
                .then(function () {
                    getOrdersData();
                });
        }

        function remove(order) {
            if (order == null) { return; }
            simpleModalService.yesNoModal('Confirmación eliminar', '¿Desea eliminar la ordern?')
                .then(function (result) {
                    if (result) {
                        notificationService.sendAppNotification({
                            message: 'Eliminando ordenes...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
                        ordersService.removeOrders([order.id]).then(function () {
                            refreshData(true);
                        }, function () {
                            notificationService.sendAppNotification({
                                message: 'Ha ocurrido un error al eliminar las ordenes',
                                positionY: 'top', positionX: 'right', delay: null, type: 'error'
                            });
                        });
                    }
                });
        }

        function goToEdit(order) {

            var uuid = order.id;
            var tabView = uuid;
            var uiView = uuid + 'Container';
            var parentStateName = 'flota.' + tabView;
            var stateName = 'flota.' + tabView + '.editar';

            var parentState = {
                url: '/' + tabView,
                abstract: true,
                sticky: true,
                views: {}
            };
            parentState.views[tabView] = {
                template: '<div ui-view="' + uiView + '"/>'
            };

            var exists = false;
            for (var i = 0; i < $state.get().length; i++) {
                if ($state.get()[i].name === parentStateName) {
                    exists = true;
                    break;
                }
            }

            if(!exists) {
                runtimeStates.addState(parentStateName, parentState);

                var state = {
                    url: '/editar?id',
                    data: { tabTitle: 'Editar orden Nro ' + order.jobOrder, tabView: tabView, icon: 'icon-128' },
                    params: { allOrdersOpen: null, accion: 'guardarCerrar', fromSearchRedirectTo: $state.$current.name },
                    views: {}
                };

                state.views[uiView] = {
                    controller: 'OrderFormController',
                    controllerAs: 'vm',
                    templateUrl: 'app/views/flota/ordenes/form_ordenGRU.html'
                };

                runtimeStates.addState(stateName, state);
            }

            $state.go(stateName, { 'id': order.id });
        }
    }
})();